import * as yup from "yup";

export const availabilitySchema = yup.object().shape({
    availability: yup.number().min(1).default(1).label("Availability")
});
